import { useMutation, useQueryClient } from '@tanstack/react-query'
import { storeComment } from './api'

export function useStoreComment(candidateId?: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: storeComment(candidateId!),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['campaigns'],
            })

            queryClient.invalidateQueries({
                queryKey: ['candidates', candidateId],
                exact: true,
            })
        },
    })
}
